import React from 'react'
import { useAlerts, ALERT_TYPES } from '../../contexts/AlertContext'
import {
  HiOutlineCheckCircle,
  HiOutlineXCircle,
  HiOutlineExclamationTriangle,
  HiOutlineInformationCircle,
  HiXMark
} from 'react-icons/hi2'

const AlertItem = ({ alert, onRemove }) => {
  const getAlertStyles = () => {
    switch (alert.type) {
      case ALERT_TYPES.SUCCESS:
        return {
          container: 'bg-green-50 border border-green-200 text-green-800',
          icon: <HiOutlineCheckCircle className="w-5 h-5 text-green-600" />,
          button: 'text-green-600 hover:text-green-800'
        }
      case ALERT_TYPES.ERROR:
        return {
          container: 'bg-red-50 border border-red-200 text-red-800',
          icon: <HiOutlineXCircle className="w-5 h-5 text-red-600" />,
          button: 'text-red-600 hover:text-red-800'
        }
      case ALERT_TYPES.WARNING:
        return {
          container: 'bg-yellow-50 border border-yellow-200 text-yellow-800',
          icon: <HiOutlineExclamationTriangle className="w-5 h-5 text-yellow-600" />,
          button: 'text-yellow-600 hover:text-yellow-800'
        }
      case ALERT_TYPES.INFO:
      default:
        return {
          container: 'bg-blue-50 border border-blue-200 text-blue-800',
          icon: <HiOutlineInformationCircle className="w-5 h-5 text-blue-600" />,
          button: 'text-blue-600 hover:text-blue-800'
        }
    }
  }

  const styles = getAlertStyles()

  return (
    <div
      className={`
        ${styles.container} px-4 py-3 rounded-lg shadow-sm mb-2 
        animate-in slide-in-from-right-full duration-300
        flex items-start gap-3
      `}
    >
      {/* Icon */}
      <div className="flex-shrink-0 mt-0.5">
        {styles.icon}
      </div>
      
      {/* Message */}
      <div className="flex-1 text-sm font-medium">
        {alert.message}
      </div>
      
      {/* Close Button */}
      <button
        onClick={() => onRemove(alert.id)}
        className={`flex-shrink-0 ${styles.button} transition-colors p-0.5 rounded-full hover:bg-black/5`}
      >
        <HiXMark className="w-4 h-4" />
      </button>
    </div>
  )
}

const AlertContainer = () => {
  const { alerts, removeAlert } = useAlerts()

  if (alerts.length === 0) {
    return null
  }

  return (
    <div className="fixed top-4 right-4 z-[99999] max-w-sm w-full space-y-2 pointer-events-none">
      <div className="pointer-events-auto">
        {alerts.map((alert) => (
          <AlertItem
            key={alert.id}
            alert={alert}
            onRemove={removeAlert}
          />
        ))}
      </div>
    </div>
  )
}

export default AlertContainer
